// Trigger for Showing More or Less Characters in Long Texts
window.showFullText = ( object ) => {
    if ( object.classList.contains('less') ) {
        object.classList.remove('less');
        object.innerHTML = object.dataset.lang === 'en' ? 'more' : 'بیشتر';
    } else {
        object.classList.add('less');
        object.innerHTML = object.dataset.lang === 'en' ? 'less' : 'کمتر';
    }
    const moreDots = document.getElementById(object.dataset.target).querySelector('.more-ellipses');
    const moreContent = document.getElementById(object.dataset.target).querySelector('.content');
    moreDots.style.display = moreDots.style.display === 'contents' || moreDots.style.display === ''
        ? 'none'
        : 'contents';
    moreContent.style.display = moreContent.style.display === 'none' || moreContent.style.display === ''
        ? 'contents'
        : 'none';
}
// Summarize Long Texts
const summarizeText = () => {
    const ellipsesText = '...';
    const defaultShowChar = 400;
    $(".summarized").each( ( index, element ) => {
        let showChar = defaultShowChar;
        if ( typeof element.dataset.summary !== typeof undefined && element.dataset.summary !== '' ) {
            showChar = element.dataset.summary;
        }
        let content = $.trim(element.textContent);
        if ( content.length > showChar ) {
            let splittedContent = content.split(' ');
            let counter = 0;
            let c = [];
            let h = [];
            splittedContent.forEach( word => {
                counter = counter + word.length;
                if ( counter < showChar ) {
                    c.push( word );
                } else {
                    h.push( word );
                }
            });
            c = c.join(' ');
            h = h.join(' ');
            let lang, moreText;
            if ( element.dataset.lang !== undefined && element.dataset.lang === 'en') {
                lang = 'en';
                moreText = 'more';
            } else {
                lang = 'fa';
                moreText = 'بیشتر';
            }
            element.innerHTML = `<div id="summarized-text-${ index }">
                <span class="summarized-content ml-1" style="display: contents;">${ c }</span>
                    <span class="more-ellipses mx-1">
                    ${ ellipsesText }
                    </span>
                    <span class="more-content">
                    <span class="content ml-2">${ h }</span>
                    <a href="javascript:void(0);" 
                        class="more-link" 
                        data-lang="${ lang }" 
                        data-target="summarized-text-${ index }" 
                        onclick="showFullText(this)">
                        ${ moreText }
                    </a>
                </span>`;
        }
    });
}
//Manage Internal Anchors
window.anchorManager = () => {
    document.querySelectorAll("a[href^='#']").forEach( item => {
        item.classList.add('anchor');
    });
    document.querySelectorAll(".anchor").forEach( item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            const element = event.target;
            let scrollTo = 0;
            if ( element.href !== '#' ) {
                scrollTo = $( '#' + element.href.substr( 1, element.href.length ) ).offset().top - 10 + 'px';
            }
            $('html, body').animate({
                scrollTop: scrollTo
            }, 1000);
        });
    });
}
//Load Objects By Animation with Specific Delay Time
function listLazyLoad(obj) {
    if(obj.data("display")) {
        var display = obj.data("display");
    }
    else {
        var display = "block";
    }
    if(obj.data("delay")) {
        var delay = obj.data("delay");
    }
    else {
        var delay = 200;
    }
    if(obj.data("start")) {
        var startingDelay = obj.data("start");
    }
    else {
        var startingDelay = 0;
    }
    setTimeout(function() {
        window.setInterval(function () {
            obj.find(".item").not(".shown").first().css("display", display).addClass("shown");
        }, delay);
    }, startingDelay);
}
//Handlebars.js
const simpleSearch = url => {
    $.ajax({
        type: "GET",
        url: url,
        success: data => {
            const source = document.getElementById("results").innerHTML;
            Handlebars.registerHelper("index", ( value, currentPage, perPage ) => {
                return parseInt((currentPage - 1) * perPage + value) + 1;
            });
            Handlebars.registerHelper("isMultiPage", value => {
                return value > 1
            });
            Handlebars.registerHelper("isCurrentPage", ( index, currentPage ) => {
                return parseInt(index + 1) === currentPage
            });
            Handlebars.registerHelper('times', ( n, currentPage ) => {
                let pages = '';
                for ( let i = 1; i <= n; ++i ) {
                    const active = currentPage === i ? 'active' : '';
                    const activePages = [i, i - 1 , i + 1, i - 2, i + 2];
                    const hidden = ( i === 1 || i === n || activePages.includes(currentPage)) ? '' : 'hidden';
                    const searchParams = new URLSearchParams(window.location.search);
                    searchParams.set("page", i.toString());
                    const queryString = url.split("?")[0] + '?' + searchParams.toString();
                    pages += '<a ' +
                        'class="' + active + ' ' + hidden + ' item" ' +
                        'onclick="simpleSearch(\'' + queryString + '\')">' +
                        i + '</a>';
                    if ( n > 5 ) {
                        if ( (i === 1 && currentPage > 3 ) || ( i === n - 1 && currentPage < n - 3 ) ) {
                            pages += '<a class="item"><i class="ellipsis horizontal icon"></i></a>';
                        }
                    }
                }

                return pages;
            });
            const template = Handlebars.compile(source);
            const context = { data: data.data, meta: data.meta };
            const html = template(context);
            $("#search-results-container").html(html);
        },
        error: () => {
            $('#search-results-container').html("<p><b>Something went wrong!</b></p>");
        }
    });
}
// Hide Components Until Page Fully Loaded
{
    $(".article-block > .item:not('.placeholder')").hide();
    $(".lazy-loading h1").fadeOut(0);
    $(".lazy-loading h1").hide();
    $(".lazy-loading h2").hide();
    $(".lazy-loading h3").hide();
    $(".lazy-loading h4").hide();
    $(".lazy-loading h5").hide();
    $(".lazy-loading h6").hide();
    $(".lazy-loading p").hide();
    $(".lazy-loading .button").hide();
    $(".lazy-loading .list .item").hide();
}
//Pagination
const pagination = limit => {
    const posts = [];
    document.querySelectorAll("#latest-articles > .items > .item").forEach( ( item ) => {
        posts.push( item );
        item.remove();
        item.classList.add('hidden');
    });
    const postsNumber = posts.length;
    const pagesNumber = Math.ceil(postsNumber / limit);
    for ( let i = 0; i < posts.length; i++ ) {
        document.querySelector("#latest-articles > .items").appendChild(posts[i]);
        document.querySelector("#latest-articles > .items > .item:last-child").setAttribute("data-order", (i + 1));
    }
    document.getElementById("latest-articles").innerHTML = document.getElementById("latest-articles").innerHTML
        + '<div id="pagination"></div>';
    for ( let pageCounter = 1; pageCounter <= pagesNumber; pageCounter++ ) {
        const active = pageCounter === 1 ? ' is-active ' : '';
        document.getElementById("pagination").innerHTML = document.getElementById("pagination").innerHTML +
            `<a class="item ${active}" data-page-number="${pageCounter}"
                data-limit="${limit}"
                onclick="switchPage(event)">
                ${pageCounter}
            </a>`;
    }
    document.querySelectorAll("#latest-articles > .items > .item").forEach( ( item ) => {
        if ( item.dataset.order <= limit ) {
            item.classList.remove('hidden');
        }
    });
}
window.switchPage = event => {
    event.preventDefault();
    const action = event.target;
    const limit = action.dataset.limit ? action.dataset.limit : 10;
    document.querySelectorAll("#latest-articles > .items > .item").forEach( ( item ) => {
        item.classList.add('hidden');
        if( item.dataset.order > (action.getAttribute("data-page-number") - 1 ) * limit
            && item.dataset.order <= action.getAttribute("data-page-number") * limit) {
            item.classList.remove('hidden');
        }
    });
    document.querySelectorAll("#pagination > a").forEach( ( item ) => {
        item.classList.remove('is-active');
    });
    action.classList.add('is-active');
}
//Widgets Management
document.querySelectorAll(".widget").forEach( element => {
    if ( element.dataset.slug !== undefined ) {
        const widgetSlug = element.dataset.slug.toLowerCase();
        if ( widgetSlug === 'author services' ) {
            element.classList.add(['hidden', 'important']);
        }
    }
});
if(document.querySelector('.mailerlite-popup-close') !== null) {
    document.querySelector('.mailerlite-popup-close').addEventListener( 'click',  event => {
        document.querySelector('.mailerlite-popup').remove();
        document.getElementById('main-content').style.paddingTop = 0;
    });
}

//Document Ready
$(function () {
    anchorManager();
    //Pagination Initialization
    if ( document.getElementById('latest-articles') ) {
        pagination(10);
    }
    if ( $("#pagination > a").length === 1 ) {
        $("#pagination").hide();
    } else {
        $("#pagination").show();
    }
    //Summarizing Long Texts
    summarizeText();
    //Remember Which Main Menu Item is Active
    $('#main-menu > a:first').addClass('active-item');
    $("#main-menu a").click( function () {
        $("#main-menu a").removeClass("active-item");
        const activeTab = $(this).parent().hasClass("sub")
            ? $(this).parent().parent().attr("data-value")
            : $(this).attr("href");
        localStorage.setItem('selectedTab', activeTab);
    });
    if ( localStorage.getItem('selectedTab') && localStorage.getItem('selectedTab').length > 0 ) {
        const activeMenu = localStorage.getItem('selectedTab');
        $("#main-menu a").removeClass("active-item");
        $("#main-menu > a[href='" + activeMenu + "']").addClass("active-item");
        $("#main-menu > div[data-value='" + activeMenu + "']").addClass("active-item");
    }
    if ( $("#operation-bar > .list") ) {
        listLazyLoad( $("#operation-bar > .list") );
    }
    $("#years-list .item").hide();
    for ( let i = 1; i <= 12; i++ ) {
        $("#years-list .item:nth-child(" + i + ")").show();
    }
    $("#years-list .more").click( () => {
        if ( $(this).attr("data-operation") === 'load-more' ) {
            $("#years-list .item").show();
            $(this).attr("data-operation", "hide");
            $(this).children("span.visible").text("hide");
            $(this).children("span.hidden").children("i")
                .removeClass("ellipsis horizontal")
                .addClass("minus square outline");
        }
        else {
            $("#years-list .item").hide();
            for ( let i = 1; i <= 8; i++ ) {
                $("#years-list .item:nth-child(" + i + ")").show();
            }
            $(this).attr("data-operation", "load-more");
            $(this).children("span.visible").text("بیشتر");
            $(this).children("span.hidden").children("i").removeClass("minus square outline").addClass("ellipsis horizontal");
        }
    });
    $(".issues.list .accordion .content > .item a").hover(function() {
        $("#issue-featured-image > .default-container .ui.dimmer").dimmer("show");
        if( $(this).data("featured-image") === undefined ) {
            setTimeout(() => {
                $("#issue-featured-image > .default-container > .ui.dimmer").dimmer("hide");
                $("#issue-featured-image > .default-container h5").text("NO COVER");
            }, 2000);
        }
        else {
            $("#issue-featured-image > .default-container").append('<img src="' + $(this).data("featured-image") + '"/>');
            $("#issue-featured-image > .default-container > img").hide().on("load", () => {
                $("#issue-featured-image > .default-container .ui.dimmer").dimmer("hide");
                $(this).show();
            });
        }
    }, function() {
        $("#issue-featured-image > .default-container > img").remove();
        $("#issue-featured-image > .default-container .ui.dimmer").dimmer("hide");
        $("#issue-featured-image > .default-container h5").text("ISSUE COVER");
    });
    $(".articleTable table").addClass("ui celled striped unstackable table");
    $(".lettering").lettering();
    //page title
    const siteHeader = $("header");
    const pageTitle = siteHeader.attr('page-title') ? siteHeader.attr('page-title') : $("h1#pageTitle").text();
    const pageId = siteHeader.attr('id');
    $("body").attr("id", pageId);
    //Menu Switch Between Items
    $('.ui .item').click( () => {
        $('.ui .item').removeClass('active');
        $(this).addClass('active');
    });
    //DropDown Menu
    $('.ui.dropdown').dropdown({on: 'hover'});
    //Sidebar
    $('.ui.sidebar').sidebar({
        dimPage: false,
        onShow: () => {
            $("aside").hide();
            $("footer > .grid > .column ").removeClass("sixteen wide column").addClass("thirteen wide column");
        },
        onHide: () => {
            $("aside").show();
            $("footer > .grid > .column ").removeClass("thirteen wide column").addClass("sixteen wide column");
        }
    });
    $('.sidebar-trigger').click( () => {
        $('.ui.sidebar').sidebar('toggle');
    });
    //Tabs
    $(".master.tabular > .item:first-child").addClass("actives");
    $('.tabular .item').tab({
        onLoad: () => {
            $(".item[data-value='" + $(this).attr("aria-target") + "']").addClass("actives");
        }
    });
    $(".master.tabular > .item").click( () => {
        $(".master.tabular > .item").removeClass("actives");
        $(this).addClass("actives");
        $("#" + $(this).attr("data-target")).text($(this).attr("data-value")).attr("data-value", $(this).attr("data-value"));
    });
    //Shape Initializer
    $('.ui.shape').shape();
    $(".shape-shift").on("click", () => {
        const shiftDirection = "flip " + $(this).attr("data-shift-direction");
        $(".ui.shape").shape(shiftDirection);
    });
    //Sticky Initializer
    setTimeout(() => {
        $('.ui.sticky').sticky({
            context: $(this).attr("aria-target"),
            offset: 50,
            bottomOffset: 50,
            pushing: true,
            observeChanges: true
        });
    }, 5000);
    //Popup Initializer
    $("a").popup();
    //Checkbox Initializer
    $(".ui.checkbox").checkbox();
    //Accordion
    $('.ui.accordion').accordion();
    //Slick Latest Articles Headers Slider
    $('.header.slick.slider').slick({
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: 50,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000
    });
    //On Start
    $(".slick.main.slider .slick-slide:first-child").addClass("animated");
    //On before slide change
    $(".slick.main.slider").on('beforeChange', function ( event, slick, currentSlide, nextSlide ) {
        $(this).find(".slick-slide:nth-child(" + parseInt(currentSlide + 1) + ")").removeClass("animated");
        $(this).find(".slick-slide:nth-child(" + parseInt(nextSlide + 1) + ")").addClass("animated");
    });
    $(".header.slick.slider").on('beforeChange', function ( event, slick, currentSlide, nextSlide ) {
        $(this).find(".slick-slide:nth-child(" + parseInt(currentSlide + 1) + ")").removeClass("animated");
        $(this).find(".slick-slide:nth-child(" + parseInt(nextSlide + 1) + ")").addClass("animated");
    });
    $("#logo-bar .logo.slick.slider")
        .on('init', function ( event, slick ) {
            $("#slider-title-board  .title").text($(".logo.slick.slider .slick-slide.slick-current").find("img").attr("alt"));
        })
        .on('beforeChange', function ( event, slick, currentSlide ) {
            $("#slider-title-board .title").text($(".logo.slick.slider .slick-slide.slick-current").next().find("img").attr("alt"));
        });
    $(".center.slick.slider").slick({
        dots: true,
        infinite: true,
        centerMode: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    if( $(".slick.slider").length > 0 ) {
        $(".plan.slick.slider").slick({
            autoplay:true,
            autoplaySpeed: 6000,
            speed: 1000,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            slide: 'div'
        });
        $(".slick.clients.slider").slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    }
    //passepartout
    $(".passepartout").append("<div class='absolute top right edge'></div>" +
        "<div class='absolute bottom left edge'></div>");
    //Item Images Handling
    $(".item").hover( function () {
        $(this).children(".image").children(".image").toggleClass("ui disabled");
    });
    $(".card").hover( function () {
        $(this).find(".image").toggleClass("ui disabled");
    });
    //Load Animation Manager
    let delay = 0;
    $(".delayed > div").hide().each( function () {
        const el = $(this);
        delay = delay + 150;
        setTimeout(function () {
            el.show();
        }, delay);
    });
    // Zoom icon
    $('.zoom-icon').bind('mouseover', function () {
        if ( $(this).hasClass('zoom-icon-in') )
            $(this).addClass('zoom-icon-in-hover');
        if ( $(this).hasClass('zoom-icon-out') )
            $(this).addClass('zoom-icon-out-hover');
    })
        .bind('mouseout', function () {
            if ($(this).hasClass('zoom-icon-in'))
                $(this).removeClass('zoom-icon-in-hover');
            if ($(this).hasClass('zoom-icon-out'))
                $(this).removeClass('zoom-icon-out-hover');
        })
        .bind('click', function () {

            if ($(this).hasClass('zoom-icon-in'))
                $('.magazine-viewport').zoom('zoomIn');
            else if ($(this).hasClass('zoom-icon-out'))
                $('.magazine-viewport').zoom('zoomOut');
        });
    $(".hovering-loader").hover( function () {
        $("#" + $(this).attr("data-target")).text($(this).attr("data-value")).addClass("active hovering-board").show();
    }, function () {
        const target = $("#" + $(this).attr("data-target"));
        target.text(target.attr("data-value")).removeClass("active hovering-board");
    });
    $(".article.body > section").addClass("ui accordion");
    //JQuery Scroll Spy
    let subjectCounter = 1;
    $(".article.body h5").each( function () {
        $(this).addClass("side divider active subject")
            .attr( "id", "subject-" + subjectCounter )
            .html("<span><i class='ui dropdown no margin icon'></i>" + $(this).text() + "</span>");
        if (!$(this).hasClass("disabled")) {
            $(this).addClass("title");
        }
        $(this).next("article").addClass("active content");
        $(".sidebar").append("<div class='anchor item' " +
            " aria-label='" + $(this).attr("id") + "'>" +
            $(this).children("span").text() + "</div>");
        subjectCounter++;
    });
    $(".article.body h5").on("scrollSpy:enter", function () {
        $(".sidebar .item").removeClass("active");
        $(".sidebar .item[aria-label='" + $(this).attr("id") + "']").addClass("active");
    });
    $(".article.body h5").scrollSpy();
    $("#go-to-top").click( function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
        $("#side-control").hide();
    });
    //Lazy Loading
    $(".lazy-loading").on("scrollSpy:enter", function () {
        $(this).removeClass("exit").addClass("enter").fadeIn(1000);
        $(this).find("h1").show();
        $(this).find("h2").show();
        $(this).find("h3").show();
        $(this).find("h4").show();
        $(this).find("h5").show();
        $(this).find("h6").show();
        $(this).find("p").show();
        var action = $(this).find(".button");
        if($(this).attr("data-action-delay") !== undefined) {
            var actionDelay = $(this).data("action-delay");
            setTimeout(function() {
                action.show();
            }, actionDelay);
        } else {
            action.show();
        }
        listLazyLoad($(this).find(".list"));
    });
    $(".lazy-loading").scrollSpy();
    //Window Scroll Watcher
    $(window).scroll( function () {
        if ($(this).scrollTop() > 300) {
            $("#side-control").show();
        }
        else {
            $("#side-control").hide();
        }
    });
    $("a[href^='#']").each( function () {
        $(this).addClass("anchor").attr("aria-label", $(this).attr("href").substring(1));
    });
    $(".anchor").click( function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#" + $(this).attr('aria-label')).offset().top
        }, 1000);
    });
    $(".articles > div:first-child").addClass("active");
    //Fixing to Viewport (Semantic UI)
    $('.overlay.fixed-box').visibility({
        type: 'fixed',
        offset: 15 // give some space from top of screen
    });
    $("#menu-trigger").click( function () {
        $("#" + $(this).attr("aria-label") + " .item:not(.active)").slideToggle();
    });
    setTimeout(function () {
        $(".article-block > .item").toggle();
    }, 4000);
    setTimeout(function () {
        $(".inpress-articles .item").show();
    }, 2000);
    $("#services .item").hover( function() {
        $(this).removeClass("four wide column").addClass("active seven wide column");
        $(this).siblings().removeClass("four wide column").addClass("three wide column");
    }, function() {
        $(this).removeClass("active seven wide column").addClass("four wide column");
        $(this).siblings().removeClass("three wide column").addClass("four wide column");
    });
    $('.jalali-date').each(function () {
        const f = $(this);
        const dtf = f.text().trim();
        const eventf = new Date(dtf);
        f.text(eventf.toLocaleDateString('fa-IR', {year:"numeric",month:"long", day:"2-digit"}));
    });
    //Search Form
    $(".search-form").each(function () {
        $(this).submit(function(e) {
            e.preventDefault();
            window.location.href = $(this).attr("action") + encodeURIComponent($(this).find("input[type='text']").val());
        });
    });
    $(".select2").select2();
});
//Click Out of a Specific Area
$(document).mouseup(function (e) {
    const container = $(".popup");
    // if the target of the click isn't the container nor a descendant of the container
    if ( !container.is(e.target) && container.has(e.target).length === 0 ) {
        container.hide();
    }
});

module.exports = simpleSearch;